/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteApiRoleV1Id } from '../fn/role/delete-api-role-v-1-id';
import { DeleteApiRoleV1Id$Params } from '../fn/role/delete-api-role-v-1-id';
import { getApiRoleV1Id$Json } from '../fn/role/get-api-role-v-1-id-json';
import { GetApiRoleV1Id$Json$Params } from '../fn/role/get-api-role-v-1-id-json';
import { getApiRoleV1Id$Plain } from '../fn/role/get-api-role-v-1-id-plain';
import { GetApiRoleV1Id$Plain$Params } from '../fn/role/get-api-role-v-1-id-plain';
import { getApiRoleV1Permissions$Json } from '../fn/role/get-api-role-v-1-permissions-json';
import { GetApiRoleV1Permissions$Json$Params } from '../fn/role/get-api-role-v-1-permissions-json';
import { getApiRoleV1Permissions$Plain } from '../fn/role/get-api-role-v-1-permissions-plain';
import { GetApiRoleV1Permissions$Plain$Params } from '../fn/role/get-api-role-v-1-permissions-plain';
import { PagedRoleSearchResponse } from '../models/paged-role-search-response';
import { PermissionModel } from '../models/permission-model';
import { postApiRoleV1$Json } from '../fn/role/post-api-role-v-1-json';
import { PostApiRoleV1$Json$Params } from '../fn/role/post-api-role-v-1-json';
import { postApiRoleV1$Plain } from '../fn/role/post-api-role-v-1-plain';
import { PostApiRoleV1$Plain$Params } from '../fn/role/post-api-role-v-1-plain';
import { postApiRoleV1IdLock } from '../fn/role/post-api-role-v-1-id-lock';
import { PostApiRoleV1IdLock$Params } from '../fn/role/post-api-role-v-1-id-lock';
import { postApiRoleV1IdUnlock } from '../fn/role/post-api-role-v-1-id-unlock';
import { PostApiRoleV1IdUnlock$Params } from '../fn/role/post-api-role-v-1-id-unlock';
import { postApiRoleV1Search$Json } from '../fn/role/post-api-role-v-1-search-json';
import { PostApiRoleV1Search$Json$Params } from '../fn/role/post-api-role-v-1-search-json';
import { postApiRoleV1Search$Plain } from '../fn/role/post-api-role-v-1-search-plain';
import { PostApiRoleV1Search$Plain$Params } from '../fn/role/post-api-role-v-1-search-plain';
import { putApiRoleV1Id$Json } from '../fn/role/put-api-role-v-1-id-json';
import { PutApiRoleV1Id$Json$Params } from '../fn/role/put-api-role-v-1-id-json';
import { putApiRoleV1Id$Plain } from '../fn/role/put-api-role-v-1-id-plain';
import { PutApiRoleV1Id$Plain$Params } from '../fn/role/put-api-role-v-1-id-plain';
import { RoleModel } from '../models/role-model';


/**
 * API controller for managing roles and their associated permissions.
 */
@Injectable({ providedIn: 'root' })
export class RoleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiRoleV1()` */
  static readonly PostApiRoleV1Path = '/private/v1/roles/create';

  /**
   * Creates a new role with its permissions.
   *
   * Creates a new role with its permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRoleV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRoleV1$Plain$Response(params?: PostApiRoleV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleModel>> {
    return postApiRoleV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new role with its permissions.
   *
   * Creates a new role with its permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRoleV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRoleV1$Plain(params?: PostApiRoleV1$Plain$Params, context?: HttpContext): Observable<RoleModel> {
    return this.postApiRoleV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleModel>): RoleModel => r.body)
    );
  }

  /**
   * Creates a new role with its permissions.
   *
   * Creates a new role with its permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRoleV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRoleV1$Json$Response(params?: PostApiRoleV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleModel>> {
    return postApiRoleV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new role with its permissions.
   *
   * Creates a new role with its permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRoleV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRoleV1$Json(params?: PostApiRoleV1$Json$Params, context?: HttpContext): Observable<RoleModel> {
    return this.postApiRoleV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleModel>): RoleModel => r.body)
    );
  }

  /** Path part for operation `getApiRoleV1Permissions()` */
  static readonly GetApiRoleV1PermissionsPath = '/private/v1/permissions';

  /**
   * Retrieves all available permissions.
   *
   * Retrieves all available permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiRoleV1Permissions$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRoleV1Permissions$Plain$Response(params?: GetApiRoleV1Permissions$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionModel>>> {
    return getApiRoleV1Permissions$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all available permissions.
   *
   * Retrieves all available permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiRoleV1Permissions$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRoleV1Permissions$Plain(params?: GetApiRoleV1Permissions$Plain$Params, context?: HttpContext): Observable<Array<PermissionModel>> {
    return this.getApiRoleV1Permissions$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PermissionModel>>): Array<PermissionModel> => r.body)
    );
  }

  /**
   * Retrieves all available permissions.
   *
   * Retrieves all available permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiRoleV1Permissions$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRoleV1Permissions$Json$Response(params?: GetApiRoleV1Permissions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionModel>>> {
    return getApiRoleV1Permissions$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all available permissions.
   *
   * Retrieves all available permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiRoleV1Permissions$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRoleV1Permissions$Json(params?: GetApiRoleV1Permissions$Json$Params, context?: HttpContext): Observable<Array<PermissionModel>> {
    return this.getApiRoleV1Permissions$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PermissionModel>>): Array<PermissionModel> => r.body)
    );
  }

  /** Path part for operation `getApiRoleV1Id()` */
  static readonly GetApiRoleV1IdPath = '/private/v1/roles/{id}';

  /**
   * Retrieves a role by ID.
   *
   * Retrieves a role by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiRoleV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRoleV1Id$Plain$Response(params: GetApiRoleV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleModel>> {
    return getApiRoleV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a role by ID.
   *
   * Retrieves a role by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiRoleV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRoleV1Id$Plain(params: GetApiRoleV1Id$Plain$Params, context?: HttpContext): Observable<RoleModel> {
    return this.getApiRoleV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleModel>): RoleModel => r.body)
    );
  }

  /**
   * Retrieves a role by ID.
   *
   * Retrieves a role by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiRoleV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRoleV1Id$Json$Response(params: GetApiRoleV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleModel>> {
    return getApiRoleV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a role by ID.
   *
   * Retrieves a role by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiRoleV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiRoleV1Id$Json(params: GetApiRoleV1Id$Json$Params, context?: HttpContext): Observable<RoleModel> {
    return this.getApiRoleV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleModel>): RoleModel => r.body)
    );
  }

  /** Path part for operation `putApiRoleV1Id()` */
  static readonly PutApiRoleV1IdPath = '/private/v1/roles/{id}';

  /**
   * Updates a role and its permissions.
   *
   * Updates a role and its permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiRoleV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiRoleV1Id$Plain$Response(params: PutApiRoleV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleModel>> {
    return putApiRoleV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a role and its permissions.
   *
   * Updates a role and its permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiRoleV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiRoleV1Id$Plain(params: PutApiRoleV1Id$Plain$Params, context?: HttpContext): Observable<RoleModel> {
    return this.putApiRoleV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleModel>): RoleModel => r.body)
    );
  }

  /**
   * Updates a role and its permissions.
   *
   * Updates a role and its permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiRoleV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiRoleV1Id$Json$Response(params: PutApiRoleV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleModel>> {
    return putApiRoleV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a role and its permissions.
   *
   * Updates a role and its permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiRoleV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiRoleV1Id$Json(params: PutApiRoleV1Id$Json$Params, context?: HttpContext): Observable<RoleModel> {
    return this.putApiRoleV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleModel>): RoleModel => r.body)
    );
  }

  /** Path part for operation `deleteApiRoleV1Id()` */
  static readonly DeleteApiRoleV1IdPath = '/private/v1/roles/{id}';

  /**
   * Deletes a role by ID.
   *
   * Deletes a role by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiRoleV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiRoleV1Id$Response(params: DeleteApiRoleV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiRoleV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a role by ID.
   *
   * Deletes a role by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiRoleV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiRoleV1Id(params: DeleteApiRoleV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiRoleV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiRoleV1Search()` */
  static readonly PostApiRoleV1SearchPath = '/private/v1/roles';

  /**
   * Retrieves all roles.
   *
   * Retrieves all roles.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRoleV1Search$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRoleV1Search$Plain$Response(params?: PostApiRoleV1Search$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedRoleSearchResponse>> {
    return postApiRoleV1Search$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all roles.
   *
   * Retrieves all roles.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRoleV1Search$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRoleV1Search$Plain(params?: PostApiRoleV1Search$Plain$Params, context?: HttpContext): Observable<PagedRoleSearchResponse> {
    return this.postApiRoleV1Search$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PagedRoleSearchResponse>): PagedRoleSearchResponse => r.body)
    );
  }

  /**
   * Retrieves all roles.
   *
   * Retrieves all roles.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRoleV1Search$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRoleV1Search$Json$Response(params?: PostApiRoleV1Search$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedRoleSearchResponse>> {
    return postApiRoleV1Search$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all roles.
   *
   * Retrieves all roles.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRoleV1Search$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiRoleV1Search$Json(params?: PostApiRoleV1Search$Json$Params, context?: HttpContext): Observable<PagedRoleSearchResponse> {
    return this.postApiRoleV1Search$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PagedRoleSearchResponse>): PagedRoleSearchResponse => r.body)
    );
  }

  /** Path part for operation `postApiRoleV1IdLock()` */
  static readonly PostApiRoleV1IdLockPath = '/private/v1/roles/{id}/lock';

  /**
   * Lock user by internal ID.
   *
   * Lock user by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRoleV1IdLock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiRoleV1IdLock$Response(params: PostApiRoleV1IdLock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiRoleV1IdLock(this.http, this.rootUrl, params, context);
  }

  /**
   * Lock user by internal ID.
   *
   * Lock user by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRoleV1IdLock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiRoleV1IdLock(params: PostApiRoleV1IdLock$Params, context?: HttpContext): Observable<void> {
    return this.postApiRoleV1IdLock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiRoleV1IdUnlock()` */
  static readonly PostApiRoleV1IdUnlockPath = '/private/v1/roles/{id}/unlock';

  /**
   * Unlock user by internal ID.
   *
   * Unlock user by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiRoleV1IdUnlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiRoleV1IdUnlock$Response(params: PostApiRoleV1IdUnlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiRoleV1IdUnlock(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlock user by internal ID.
   *
   * Unlock user by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiRoleV1IdUnlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiRoleV1IdUnlock(params: PostApiRoleV1IdUnlock$Params, context?: HttpContext): Observable<void> {
    return this.postApiRoleV1IdUnlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
